import React from "react";

import PurchasesTable from "../PurchasesTable";
import SubscriptionsTable from "../SubscriptionsTable";
import SalesByOfferCard from "./SalesByOfferCard";
import SubscriptionsByOfferCard from "./SubscriptionsByOfferCard";
import SubscriptionsKpiGrid from "./SubscriptionsKpiGrid";
import SubscriptionsTimelineCard from "./SubscriptionsTimelineCard";

import type { JSX } from "react";

import type { OfferAnalyticsFilterProps } from "../offerAnalytics.types";

function SubscriptionsTab({ filters }: OfferAnalyticsFilterProps): JSX.Element {
  return (
    <div className="flex flex-col gap-4">
      <SubscriptionsKpiGrid filters={filters} />
      <SubscriptionsTimelineCard filters={filters} />
      <div className="grid gap-4 @3xl:grid-cols-2">
        <SubscriptionsByOfferCard filters={filters} />
        <SalesByOfferCard filters={filters} />
      </div>
      <SubscriptionsTable filters={filters} />
      <PurchasesTable filters={filters} />
    </div>
  );
}

export default SubscriptionsTab;
